import { render, staticRenderFns } from "./ProfileNav.vue?vue&type=template&id=243413e0&"
import script from "./ProfileNav.vue?vue&type=script&lang=js&"
export * from "./ProfileNav.vue?vue&type=script&lang=js&"
import style0 from "./ProfileNav.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports